import React from "react";

import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import { ReactComponent as ArrowRight } from "../../../static/images/arrow-right.svg";
import { RootState } from "../../../store/root_reducer";

import styles from "./styles.module.css";

export const FAQCategoriesPage: React.FC = () => {
  const state = useSelector((root: RootState) => root.FAQ);

  return (
    <ul className={styles.categories}>
      {state.categories.map((category, idx) => (
        <li key={idx} id={`category-${idx}`} className={styles.category}>
          <h2>{category.title}</h2>

          <ul className={styles.articles}>
            {category.articles.map((article, articleIdx) => (
              <li key={`article-${articleIdx}`} className={styles.article}>
                <Link className={styles.link} to={`/faq/${article.slug}`}>
                  <h3>{article.title}</h3>
                  <ArrowRight />
                </Link>
              </li>
            ))}
          </ul>
        </li>
      ))}
    </ul>
  );
};
